import React, { useEffect, useState, useContext } from "react";
import {
  Table,
  Spin,
  Card,
  Input,
  Button,
  Space,
  message,
  Switch,
  Tooltip,
  Select 
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  UserOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { Avatar } from "antd";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import httpInjectorService from "../../services/http-injector.service";
import { NotificationContext } from "../../NotificationProvider";
import { useRefresh } from "../../RefreshContext";
import { Col, Row } from "reactstrap";

const Employeelist = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [editedRow, setEditedRow] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const { openNotification } = useContext(NotificationContext);
  const { refreshKey, triggerRefresh } = useRefresh();
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    fetchData();
  }, [refreshKey]);

  // const formatDate = (dateStr) => {
  //   if (!dateStr) return "";
  //   const date = new Date(dateStr);
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const year = String(date.getFullYear()).slice(-2);
  //   return `${day}-${month}-${year}`;
  // };
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear(); // full 4-digit year
    return `${day}-${month}-${year}`;
  };

  const fetchData = async () => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 500));
    try {
      const res = await httpInjectorService.employeeList();
      console.log(res, "responseemployee");
      if (res.status === "SUCCESS") {
        const sorted = res.data.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at),
        );
        setData(sorted);
      } else {
        setData([]);
        message.warning("No employees found.");
      }
    } catch (e) {
      console.error(e);
      message.error("Failed to fetch employee list.");
    } finally {
      setLoading(false);
    }
  };

  const startEditing = (record) => {
    setEditingId(record.id);
    setEditedRow({ ...record });
  };

  const cancelEditing = () => {
    setEditingId(null);
    setEditedRow({});
  };

  const handleChange = (e, field) => {
    if (field === "status") {
      setEditedRow((prev) => ({ ...prev, status: e ? "active" : "blocked" }));
    } else {
      setEditedRow((prev) => ({ ...prev, [field]: e.target.value }));
    }
  };

  // const saveChanges = async () => {
  //   const orig = data.find((r) => r.id === editingId);
  //   if (!orig) return;

  //   const payload = { id: editingId };
  //   Object.keys(editedRow).forEach((key) => {
  //     if (editedRow[key] !== orig[key]) payload[key] = editedRow[key];
  //   });

  //   if (Object.keys(payload).length === 1) {
  //     openNotification("info", "No changes detected");
  //     return cancelEditing();
  //   }

  //   try {
  //     const res = await httpInjectorService.updateEmployeeDetails(payload);
  //     if (res.status === "SUCCESS") {
  //       openNotification("success", res.message);
  //       cancelEditing();
  //       fetchData();
  //     } else openNotification("error", res.message);
  //   } catch (e) {
  //     console.error(e);
  //     openNotification("error", "Failed to update employee");
  //   }
  // };

  const saveChanges = async () => {
  const orig = data.find((r) => r.id === editingId);
  if (!orig) return;

  const payload = { id: editingId };

  Object.keys(editedRow).forEach((key) => {
    if (editedRow[key] !== orig[key]) {
      payload[key] = editedRow[key];
    }
  });

  // If either first_name or last_name changed,
  // always send both values so backend can build user_name correctly.
  if (
    payload.first_name !== undefined ||
    payload.last_name !== undefined
  ) {
    payload.first_name =
      payload.first_name !== undefined
        ? payload.first_name
        : orig.first_name;

    payload.last_name =
      payload.last_name !== undefined
        ? payload.last_name
        : orig.last_name;
  }

  if (Object.keys(payload).length === 1) {
    openNotification("info", "No changes detected");
    return cancelEditing();
  }

  try {
    const res = await httpInjectorService.updateEmployeeDetails(payload);
    if (res.status === "SUCCESS") {
      openNotification("success", res.message);
      cancelEditing();
      fetchData();
    } else {
      openNotification("error", res.message);
    }
  } catch (e) {
    console.error(e);
    openNotification("error", "Failed to update employee");
  }
};
  const filtered = data.filter((emp) => {
    const term = searchTerm.toLowerCase();
    const joiningDate = formatDate(emp.created_at).toLowerCase();

    return (
      emp.user_name?.toLowerCase().includes(term) ||
      emp.work_number?.toLowerCase().includes(term) ||
      emp.company_name?.toLowerCase().includes(term) ||
      emp.company_branch?.toLowerCase().includes(term) ||
      emp.status?.toLowerCase().includes(term) ||
      joiningDate.includes(term)
    );
  });

  const formatSortCode = (code) => {
    return code?.match(/.{1,2}/g)?.join("-") || "";
  };
  const capitalizeWords = (str) => {
    if (!str) return "";
    return str
      .toLowerCase() // make everything lowercase first
      .replace(/\b\w/g, (char) => char.toUpperCase()); // then capitalize first letter of each word
  };

  const formatNINumber = (value) => {
    if (!value) return "";

    // Remove spaces and ensure uppercase
    const clean = value.toUpperCase().replace(/\s+/g, "");

    // Split into chunks of 2 characters
    const pairs = clean.match(/.{1,2}/g);

    return pairs ? pairs.join(" ") : value;
  };

  const formatPostCode = (code) => {
    if (!code || code.length < 4) return code;
    const part1 = code.slice(0, code.length - 3);
    const part2 = code.slice(-3);
    return `${part1} ${part2}`;
  };

  // const formatPhoneNumber = (phone) => {
  //   if (!phone) return "";
  //   return phone.startsWith("44") ? "0" + phone.slice(2) : phone;
  // };

  const formatPhoneNumber = (phone) => {
    if (!phone) return "";
    phone = phone.replace(/\D/g, "");
    let countryCodeLength = phone.startsWith("1") ? 1 : 2;
    const countryCode = phone.slice(0, countryCodeLength);
    const localNumber = phone.slice(countryCodeLength);
    return `+${countryCode} ${localNumber}`;
  };

  const handleDownloadExcel = async () => {
    if (!data || data.length === 0) {
      message.warning("No data to export.");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Employees");

    // Define the desired columns
    worksheet.columns = [
      { header: "S.NO", key: "sno", width: 5 },
      { header: "TITLE", key: "title", width: 7 },
      { header: "FIRST NAME", key: "first_name", width: 15 },
      { header: "LAST NAME", key: "last_name", width: 15 },
      { header: "GENDER", key: "gender", width: 15 },
      { header: "EMPLOYEE ID", key: "work_number", width: 20 },
      { header: "EMAIL", key: "email", width: 25 },
      {header: "SESSION ID", key: "session_id", width: 25},
      {header: "USER KEY", key:"user_key", width:25},
      { header: "COMPANY", key: "company_name", width: 25 },
      { header: "BRANCH", key: "company_branch", width: 25 },

      { header: "DATE OF BIRTH", key: "date_of_birth", width: 15 },

      {
        header: "NATIONAL INSURANCE NUMBER",
        key: "national_insurance_number",
        width: 25,
      },

      { header: "PHONE", key: "phone", width: 25 },
      { header: "ADDRESS LINE 1", key: "address_line_1", width: 25 },
      { header: "ADDRESS LINE 2", key: "address_line_2", width: 25 },
      { header: "POST CODE", key: "post_code", width: 15 },
      {
        header: "BANK NAME",
        key: "bank_name",
        width: 25,
      },
      { header: "ACCOUNT NUMBER", key: "account_number", width: 25 },
      { header: "SORT CODE", key: "sort_code", width: 15 },
      { header: "JOINING DATE", key: "joining_date", width: 15 },
      {header:"YOTI STATUS", key:"yoti_status", width:10},
      { header: "STATUS", key: "status", width: 15 },
    ];

    // Populate rows
    data.forEach((row, index) => {
      worksheet.addRow({
        sno: index + 1,
        title: row.title,
        first_name: capitalizeWords(row.first_name),
        last_name: capitalizeWords(row.last_name),
        gender: row.gender,
        work_number: row.work_number,
        email: row.email,
        session_id: row.session_id,
        user_key:row.user_key,
        company_name: row.company_name,
        company_branch: row.company_branch,
        date_of_birth: row.date_of_birth,
        national_insurance_number: formatNINumber(
          row.national_insurance_number,
        ),
        phone: formatPhoneNumber(row.phone),
        address_line_1: capitalizeWords(row.address_line_1),
        address_line_2: capitalizeWords(row.address_line_2),
        post_code: formatPostCode(row.post_code),
        bank_name: row.bank_name.toUpperCase(),
        account_number: row.account_number,
        sort_code: formatSortCode(row.sort_code),
        joining_date: formatDate(row.created_at),
        yoti_status:row.yoti_status,
        status: row.status,
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "employee_list.xlsx");
  };

  // const handleDownloadCSV = () => {
  //   const worksheet = XLSX.utils.json_to_sheet(data);
  //   const csvOutput = XLSX.utils.sheet_to_csv(worksheet);
  //   const blob = new Blob([csvOutput], { type: 'text/csv;charset=utf-8;' });
  //   saveAs(blob, 'employee_list.csv');
  // };

  const columns = [
    {
      title: "S.No",
      dataIndex: "index",
      width: 60,
      render: (_, __, idx) => idx + 1,
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
    },
{
  title: "Title",
  dataIndex: "title",
  sorter: (a, b) => a.title.localeCompare(b.title),
  onHeaderCell: () => ({
    style: { backgroundColor: "#5167c1", color: "black" },
  }),
  render: (_, record) =>
    editingId === record.id ? (
      <Input
        value={editedRow.title}
        onChange={(e) => handleChange(e, "title")}
      />
    ) : (
      record.title
    ),
},
    {
      title: "First Name",
      dataIndex: "first_name",
      sorter: (a, b) => a.first_name.localeCompare(b.first_name),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
     render: (_, record) =>
      editingId === record.id ? (
      <Input
      value={editedRow.first_name}
      onChange={(e) => handleChange(e, "first_name")}
        />
      ) : (
      <Space size={14}>
        <Avatar size="small" icon={<UserOutlined />} />
        <span>{capitalizeWords(record.first_name)}</span>
      </Space>
      ),
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      sorter: (a, b) => a.last_name.localeCompare(b.last_name),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
     render: (_, record) =>
        editingId === record.id ? (
        <Input
          value={editedRow.last_name}
          onChange={(e) => handleChange(e, "last_name")}
        />
       ) : (
        capitalizeWords(record.last_name)
       ),
    },
    {
  title: "Gender",
  dataIndex: "gender",
  sorter: (a, b) => a.gender.localeCompare(b.gender),
  onHeaderCell: () => ({
    style: { backgroundColor: "#5167c1", color: "black" },
  }),
  render: (_, record) =>
    editingId === record.id ? (
      <Select
        value={editedRow.gender}
        style={{ width: "100%" }}
        onChange={(value) =>
          handleChange({ target: { value } }, "gender")
        }
        options={[
          { label: "Male", value: "male" },
          { label: "Female", value: "female" },
          { label: "Other", value: "other" },
        ]}
      />
    ) : (
      capitalizeWords(record.gender)
    ),
},
    {
      title: "Work Number",
      dataIndex: "work_number",
      sorter: (a, b) => a.work_number.localeCompare(b.work_number),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
      render: (_, record) =>
        editingId === record.id ? (
          <Input
            value={editedRow.work_number}
            onChange={(e) => handleChange(e, "work_number")}
          />
        ) : (
          record.work_number
        ),
    },
   {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
      onHeaderCell: () => ({
      style: { backgroundColor: "#5167c1", color: "black" },
    }),
       render: (_, record) =>
       editingId === record.id ? (
        <Input
        value={editedRow.email}
        onChange={(e) => handleChange(e, "email")}
      />
        ) : (
         record.email
      ),
    },
    {
      title: "SessionId",
      dataIndex: "session_id",
      sorter: (a, b) => a.session_id.localeCompare(b.session_id),
      onHeaderCell: () => ({
      style: { backgroundColor: "#5167c1", color: "black" },
    }),
      
    },
    {
      title: "User Key",
      dataIndex: "user_key",
      sorter: (a, b) => a.user_key.localeCompare(b.user_key),
      onHeaderCell: () => ({
      style: { backgroundColor: "#5167c1", color: "black" },
    }),
      
    },
    {
      title: "Branch",
      dataIndex: "company_branch",
      sorter: (a, b) => a.company_branch.localeCompare(b.company_branch),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
      render: (_, record) =>
        editingId === record.id ? (
          <Input
            value={editedRow.company_branch}
            onChange={(e) => handleChange(e, "company_branch")}
          />
        ) : (
          record.company_branch
        ),
    },
    {
      title: "Company",
      dataIndex: "company_name",
      sorter: (a, b) => a.company_name.localeCompare(b.company_name),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
      render: (_, record) =>
        editingId === record.id ? (
          <Input
            value={editedRow.company_name}
            onChange={(e) => handleChange(e, "company_name")}
          />
        ) : (
          record.company_name
        ),
    },
    {
      title: "DOB",
      dataIndex: "date_of_birth",
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
    },
    {
      title: "National Insurance Number",
      dataIndex: "national_insurance_number",
      render: (text) => formatNINumber(text),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
    },

    {
      title: "Phone",
      dataIndex: "phone",
      render: (phone) => formatPhoneNumber(phone),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
    },
    {
      title: "Address_line1",
      dataIndex: "address_line_1",
      render: (text) => capitalizeWords(text),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
    },
    {
      title: "Address_line2",
      dataIndex: "address_line_2",
      render: (text) => capitalizeWords(text),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
    },

    {
      title: "Post Code",
      dataIndex: "post_code",
      render: (text) => formatPostCode(text),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
    },
    {
      title: "Bank Name",
      dataIndex: "bank_name",
      sorter: (a, b) => a.bank_name.localeCompare(b.bank_name),
      render: (text) => text?.toUpperCase(),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
    },
    {
      title: "Account Number",
      dataIndex: "account_number",
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
    },
    {
      title: "Sort code",
      dataIndex: "sort_code",
      render: (text) => text?.match(/.{1,2}/g)?.join("-") || "", 
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
    },

    {
      title: "Joining Date",
      dataIndex: "created_at",
      render: (text) => formatDate(text),
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
    },

     {
      title: "Yoti Status",
      dataIndex: "yoti_status",
      sorter: (a, b) => a.yoti_status.localeCompare(b.yoti_status),
      onHeaderCell: () => ({
      style: { backgroundColor: "#5167c1", color: "black" },
    }),
      
    },

    {
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
      render: (_, record) => {
        if (editingId === record.id) {
          return (
            <Switch
              checked={editedRow.status === "active"}
              onChange={(checked) => handleChange(checked, "status")}
              checkedChildren="Active"
              unCheckedChildren="Blocked"
            />
          );
        }

        const isActive = record.status === "active";

        return (
          <span
            style={{
              backgroundColor: isActive ? "#52c41a" : "#f5222d",
              color: "#fff",
              padding: "2px 12px",
              borderRadius: "16px",
              fontSize: "12px",
              fontWeight: 500,
              display: "inline-block",
              minWidth: 70,
              textAlign: "center",
              textTransform: "capitalize",
              userSelect: "none",
            }}
          >
            {record.status}
          </span>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      fixed: "right",
      render: (_, record) =>
        editingId === record.id ? (
          <Space>
            <Button type="primary" onClick={saveChanges}>
              Save
            </Button>
            <Button onClick={cancelEditing}>Cancel</Button>
          </Space>
        ) : (
          <Tooltip title="Edit employee">
            <Button
              icon={<EditOutlined />}
              onClick={() => startEditing(record)}
            />
          </Tooltip>
        ),
      onHeaderCell: () => ({
        style: { backgroundColor: "#5167c1", color: "black" },
      }),
      width: 120,
    },
  ];

  return (
    <div>
      <Card bordered className="mt-2">
        {/* <Row
          className="align-items-center mb-3"
          style={{ gap: 16, flexWrap: "wrap" }}
        >
          <Col className="col-sm-2">
            <select
              className="form-select"
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
            >
              {[10, 20, 30, 40, 50].map((size) => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </select>
          </Col>

          <Col className="col-sm-3">
            <div className="position-relative">
              <i
                className="bx bx-search-alt"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "12px",
                  transform: "translateY(-50%)",
                  fontSize: "18px",
                  color: "#aaa",
                }}
              ></i>
              <input
                onChange={(e) => setSearchTerm(e.target.value)}
                id="search-bar-0"
                type="text"
                className="form-control ps-5"
                placeholder={`${filtered.length} record${
                  filtered.length !== 1 ? "s" : ""
                }...`}
                value={searchTerm || ""}
                style={{ height: "38px" }}
              />
            </div>
          </Col>
        </Row> */}
        <Row
          className="align-items-center mb-3"
          style={{ gap: 16, flexWrap: "wrap" }}
        >
          <Col className="col-sm-2">
            <select
              className="form-select"
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
            >
              {[10, 20, 30, 40, 50].map((size) => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </select>
          </Col>

          <Col className="col-sm-3">
            <div className="position-relative">
              <i
                className="bx bx-search-alt"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "12px",
                  transform: "translateY(-50%)",
                  fontSize: "18px",
                  color: "#aaa",
                }}
              ></i>
              <input
                onChange={(e) => setSearchTerm(e.target.value)}
                id="search-bar-0"
                type="text"
                className="form-control ps-5"
                placeholder={`${filtered.length} record${
                  filtered.length !== 1 ? "s" : ""
                }...`}
                value={searchTerm || ""}
                style={{ height: "38px" }}
              />
            </div>
          </Col>

          <Col className="ms-auto col-sm-2 text-end">
            <button
              style={{ backgroundColor: "#5167c1", color: "black" }}
              className="btn"
              onClick={handleDownloadExcel}
            >
              <i className="bx bx-download me-1"></i>
              Download
            </button>
          </Col>
        </Row>

        <Spin spinning={loading}>
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              overflowY: "scroll",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
            className="hide-scrollbar"
          >
            <Table
              key={searchTerm}
              columns={columns}
              dataSource={filtered}
              pagination={filtered.length > pageSize ? { pageSize } : false}
              rowKey="id"
              scroll={{ x: "max-content" }}
            />
          </div>
        </Spin>
      </Card>
    </div>
  );
};

export default Employeelist;
